export const GET_SESSION_REQUESTED = 'GET_SESSION_REQUESTED';
export const GET_SESSION_COMPLETED = 'GET_SESSION_COMPLETED';
export const GET_SESSION_FAILED = 'GET_SESSION_FAILED';
